const postalCodeOrLowerLocationTypes = ["neighborhood", "postal_code", "premise", "route", "street_address"];

const cityOrLowerLocationTypes = ["administrative_area_level_1", "locality", ...postalCodeOrLowerLocationTypes];

const validCountries = [
  "Bahrain",
  "Brunei",
  "Djibouti",
  "Gibraltar",
  "Grenada",
  "Hong Kong",
  "Liechtenstein",
  "Macau",
  "Maldives",
  "Malta",
  "Marshall Islands",
  "Monaco",
  "Qatar",
  "Singapore",
  "St Kitts & Nevis",
  "Vatican City"
];

export const filterLocationsToCityOrLower = (locations: google.maps.places.AutocompletePrediction[]) =>
  locations.filter(location => {
    if (location.types.some(type => cityOrLowerLocationTypes.includes(type))) {
      return true;
    }

    if (location.types.includes("country")) {
      return validCountries.includes(location.description);
    }

    return false;
  });

export const filterLocationsToPostalCodeOrLower = (locations: google.maps.places.AutocompletePrediction[]) =>
  locations.filter(location => {
    if (location.types.some(type => postalCodeOrLowerLocationTypes.includes(type))) {
      return true;
    }
    return false;
  });
